import { render, staticRenderFns } from "./AssetLogThreeDimension.vue?vue&type=template&id=8742b1aa"
import script from "./AssetLogThreeDimension.vue?vue&type=script&lang=js"
export * from "./AssetLogThreeDimension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports